/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import _ from 'lodash';
import React from 'react';
import { Col } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { notification, Radio, Select, Col as AntdCol, Row as AntdRow } from 'antd';
import { HiViewList, HiViewGrid } from 'react-icons/hi';
import { queryFirst } from 'helpers/QueryHelper';
import Card from 'components/Containers/Card';
import { start } from 'modules/Olympic/actions';
import Container from 'components/Containers/Container';
import OlympicListCard from 'modules/Olympic/components/OlympicCard/OlympicListCard';
import OlympicGridCard from 'modules/Olympic/components/OlympicCard/OlympicGridCard';
import styles from './styles.module.css';

const { Option } = Select;

const classData = [
  { value: 1, name: 'Lớp 1', match: 1 },
  { value: 2, name: 'Lớp 2', match: 2 },
  { value: 3, name: 'Lớp 3', match: 4 },
  { value: 4, name: 'Lớp 4', match: 8 },
  { value: 5, name: 'Lớp 5', match: 7 },
];

const cardContent = (tagName, title) => {
  return {
    tagName,
    title,
    skills: [
      { name: 'One Choice', visible: true },
      { name: 'Fill In The Blank', visible: true },
      { name: 'Unscramble', visible: true },
      { name: 'Matching ', visible: true },
      { name: 'Word Puzzles', visible: true },
      { name: 'Underlined', visible: true },
      { name: 'Select Word', visible: true },
    ],
    color: ['#FD9726', '#2ACFD3', '#F24422', '#7A57CE', '#8BC427', '#00A1DE'],
  };
};

const OlympicPractice = ({ loggedInUser }) => {
  const { href } = window.location;
  const dev = href.includes('localhost');

  const dispatch = useDispatch();
  const history = useHistory();
  const level = localStorage.getItem('classLevel');
  const [classLevel, setClassLevel] = React.useState(level ?? 4);
  const [examinations, setExaminations] = React.useState([]);
  const olympicView = localStorage.getItem('olympicView');
  const [view, setView] = React.useState(olympicView ?? 'list');

  const classId = classData.find(x => x.match === loggedInUser.classId);

  const onChange = (value) => {
    setClassLevel(value);
    localStorage.setItem('classLevel', value);
  };

  const renderSelect = () => {
    return (
      <Select
        showSearch
        style={{ width: 100 }}
        optionFilterProp="children"
        onChange={onChange}
        defaultValue={parseInt(classLevel)}
        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
      >
        {classData.map((item) => <Option key={item.value} value={item.value}>{item.name}</Option>)}
      </Select>
    );
  };

  const renderTitle = () => {
    return (
      <div className="d-flex justify-content-between align-items-center">
        <div>Olympic English</div>
        <div className="d-flex">
          {dev && renderSelect()}
          <Col span={16} style={{ textAlign: 'end' }}>
            <Radio.Group
              defaultValue={view}
              buttonStyle='solid'
              onChange={(e) => {
                setView(e.target.value);
                localStorage.setItem('olympicView', e.target.value);
              }}
            >
              <Radio.Button value='list'>
                <HiViewList />
              </Radio.Button>
              <Radio.Button value='card'>
                <HiViewGrid />
              </Radio.Button>
            </Radio.Group>
          </Col>
        </div>
      </div>
    );
  };

  const getQuestion = async (e, index) => {
    // const originalExamination = await queryFirst('p_SACHSO_OLYMPIC_DETHI_Get', { classLevel, examinationCode: e }, 'SGK');
    const originalExamination = await queryFirst('p_SACHSO_OLYMPIC_DETHI_Get', { classLevel: dev ? classLevel : classId.value, examinationCode: e }, 'SGK');

    // const originalExamination = await queryFirst('p_SACHSO_OLYMPIC_DETHI_Get', { classLevel: 4, examinationCode: e }, 'SmartEducation');
    const examination = _.cloneDeep(originalExamination);
    if (!examination) return notification.warning({ message: 'Không có câu hỏi để hiển thị !' });
    // FIXED
    examination.questions.forEach((q) => {
      if (_.startsWith(q.answers, '[{')) {
        q.answers = JSON.parse(q.answers);
      }

      if (_.startsWith(q.settings, '{')) {
        q.settings = JSON.parse(q.settings);
      }
    });

    // console.log('Examination: ', examination);

    dispatch(start(examination));
    return history.push(`/lms/olympic/examination/${index}/start/1`);
  };

  React.useEffect(() => {
    const exams = [];
    for (let i = 1; i <= 6; i++) {
      exams.push(i);
    }
    setExaminations(exams);
  }, [examinations.length]);

  if (!dev && !classId) {
    return (
      <Container name='Trang chủ' parentName="Olympic English">
        <Card title={renderTitle()}>
          <h1>Không có bài luyện tập nào được hiển thị!</h1>
        </Card>
      </Container>
    );
  }
  return (
    <Container name='Trang chủ' parentName="Olympic English">
      <Card
        className={styles['card-background']}
        title={renderTitle()}
      >
        <h1 style={{ color: 'white' }}>{`Chọn đề luyện tập lớp ${dev ? classLevel : classId.value}`}</h1>
        {view === 'list' ? examinations.map((e, index) => {
          return (
            <div key={e}>
              <OlympicListCard index={index} exercise={cardContent(index + 1, `Đề số ${index + 1}`)} onClick={() => getQuestion(e, index + 1)} />
            </div>
          );
        })
          : <div className="d-flex justify-content-center">
            <AntdRow gutter={[16, 16]} style={{ maxWidth: 990, alignSelf: 'center' }}>
              {examinations.map((e, index) => {
                return (
                  <AntdCol span={24} sm={12} md={8} key={e}>
                    <OlympicGridCard index={index} exercise={cardContent(index + 1, `Đề số ${index + 1}`)} onClick={() => getQuestion(e, index + 1)} />
                  </AntdCol>
                );
              })}
            </AntdRow>
          </div>}
      </Card>
    </Container>
  );
};

export default OlympicPractice;
